var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKontakt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 32,
    cy: 32,
    r: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside",
    transform: "translate(-591.000000, -1134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(591.000000, 1134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-gjenstand-"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-element",
    mask: "url(#mask-2)",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAV-Brand/farge/Gr\\xF8nn/-Gr\\xF8nn",
    mask: "url(#mask-4)",
    fill: "#99C2E8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    points: "0 64 64 64 64 0 0 0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(19.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices/-phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1439429,42 L2.85605714,42 C1.27799866,42 0,40.8153977 0,39.3537102 L0,2.64544244 C0,1.18460235 1.27799866,0 2.85605714,0 L23.1439429,0 C24.7220013,0 26,1.18460235 26,2.64544244 L26,39.3537102 C26,40.8153977 24.7220013,42 23.1439429,42 Z",
    id: "Fill-8",
    fill: "#59514B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 3,
    y: 3,
    width: 20,
    height: 31,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,38 C15,39.1044776 14.1050716,40 12.9995147,40 C11.8958991,40 11,39.1044776 11,38 C11,36.8955224 11.8958991,36 12.9995147,36 C14.1050716,36 15,36.8955224 15,38",
    id: "Fill-12",
    fill: "#E7E9E9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(5.000000, 12.000000)",
    fill: "#5EAEC7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.267066067,4.72121851 C0.6206693,5.09292716 1.19222906,5.09292716 1.54583229,4.72121851 C5.10348758,0.981401796 10.8962813,0.981401796 14.4539366,4.72121851 C14.8075398,5.09292716 15.3790996,5.09292716 15.7327028,4.72121851 C16.0890991,4.34657382 16.0890991,3.7365839 15.7327028,3.36193922 C11.5419793,-1.04336045 4.7697284,-1.11931389 0.489986744,3.13407889 L0.267066067,3.36193922 C-0.0892224409,3.73647065 -0.0888215475,4.3471085 0.267066067,4.72121851 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.413496,8.23249186 C12.7757815,8.58916938 13.3468875,8.58916938 13.709173,8.23249186 C14.0969423,7.85072492 14.0969423,7.20979221 13.709173,6.82802528 C10.5563354,3.72399157 5.44341175,3.72399157 2.29057416,6.82802528 C1.90291711,7.20968165 1.90336685,7.85127827 2.29057416,8.23249186 C2.62266917,8.55944625 3.13023147,8.58669245 3.49157104,8.31423046 L3.58625114,8.23249186 C6.01495311,5.84138462 9.98498978,5.84157734 12.413496,8.23249186 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53364145,11.7123682 C9.86899565,12.0958773 10.4095492,12.0958773 10.7449034,11.7123682 C11.0850322,11.3233989 11.0850322,10.6881787 10.7449034,10.2992094 C9.23024187,8.5670516 6.76974141,8.5668088 5.25486758,10.2992094 C4.91485229,10.6880489 4.91523605,11.3239676 5.25486758,11.7123682 C5.5644253,12.0663766 6.04882743,12.093608 6.3852843,11.7940625 L6.46612952,11.7123682 C7.3104944,10.7467576 8.68927657,10.7467576 9.53364145,11.7123682 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontakt);
export default __webpack_public_path__ + "static/media/Kontakt.3e61a68f80295e26cd5df36ebc96908d.svg";
export { ForwardRef as ReactComponent };